<div #wrapper class="daily-changes-wrapper">
    <app-modal-header [text]="'dashboard_extra_load_long' | localise" [bold]="true" (close)="bsModalRef.hide()"></app-modal-header>

    <div class="modal-body" [ngClass]="isIOS() === true ? 'ios' : ''">
        <h2 class="title-bg">{{ 'dashboard_increased_levels_stress_question' | localise}}</h2>

        <div class="form-check"
             *ngFor="let level of stressLevels">
            <label class="form-check-label toggle-check">
                <app-toggle-switch [toggled]="enabledByStressLevel[level.id]"
                                   (onChange)="markStressLevel(level.id)"></app-toggle-switch>

                <span class="toggle-check-text">
                {{ level.title }}
                </span>
            </label>
        </div>

        <h2 class="title-bg">{{ 'dashboard_increased_mental_work_question' | localise }}</h2>

        <div class="form-check"
             *ngFor="let level of brainLevels">
            <label class="form-check-label toggle-check">
                <app-toggle-switch [toggled]="enabledByBrainLevels[level.id]"
                                   (onChange)="markBrainLevel(level.id)"></app-toggle-switch>

                <span class="toggle-check-text">
                {{ level.title }}

                    <ng-container *ngIf="minsByBrainLevels[level.id]">
                    <strong>- {{ minsByBrainLevels[level.id] }} мин.</strong>
                </ng-container>
                </span>
            </label>
        </div>


        <h2 class="title-bg">{{ 'dashboard_increased_daily_physical_question' | localise }}</h2>

        <div class="form-check"
             *ngFor="let activity of dailyChangesActivities">
            <label class="form-check-label toggle-check">
                <app-toggle-switch [toggled]="enabledByActivities[activity.id]"
                                   (onChange)="markActivity(activity.id)"></app-toggle-switch>

                <span class="toggle-check-text">
                {{ activity.title }}

                    <ng-container *ngIf="minsByActivities[activity.id]">
                    <strong>- {{ minsByActivities[activity.id] }} мин.</strong>
                    <strong>({{ (userProfile.weight * minsByActivities[activity.id] * activity.multiple_per_kg).toFixed(0) }} kcal)</strong>
                </ng-container>
                </span>
            </label>
        </div>
    </div>

    <div class="modal-footer" [ngClass]="isIOS() === true ? 'ios' : ''">
        <button type="button" class="btn btn-secondary" (click)="bsModalRef.hide()">{{ 'back' | localise }}</button>
        <button type="button" class="btn btn-success" (click)="save()">{{ 'save' | localise }}</button>
    </div>
</div>
